/* unplugin-vue-components disabled */import { render } from "./sxgcmaproutelist.vue?vue&type=template&id=cbe1c4b4&scoped=true"
import script from "./sxgcmaproutelist.vue?vue&type=script&lang=js"
export * from "./sxgcmaproutelist.vue?vue&type=script&lang=js"

import "./sxgcmaproutelist.vue?vue&type=style&index=0&id=cbe1c4b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe1c4b4"]])

export default __exports__